import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-documents-sidebar',
  templateUrl: './documents-sidebar.component.html',
  styleUrls: ['./documents-sidebar.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, RouterModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class SidebarDocumentsComponent implements OnInit {

  constructor(private modalCtrl: ModalController) { }

  ngOnInit() {/* empty */}

  dismiss() { this.modalCtrl.dismiss(); }

}
